export const EMPLOYEE_TOUR_STEPS = [
  {
    selector: '[data-tour="emp-dashboard"]',
    title: 'Your Dashboard',
    description: 'Leave balances, recent requests, and quick actions all in one place.',
  },
  {
    selector: '[data-tour="emp-planner"]',
    title: 'Work Planner',
    description: 'Click days to mark WFH, Remote, or leave — entries sync to your Outlook calendar automatically (adds and removes).',
  },
  {
    selector: '[data-tour="emp-requests"]',
    title: 'My Requests',
    description: 'Track every leave request — pending, approved, or rejected. Cancel one you no longer need and it\'ll clear from Outlook too.',
  },
  {
    selector: '[data-tour="emp-team-calendar"]',
    title: 'Team Calendar',
    description: 'See who\'s in the office, WFH, remote, or on leave. Subscribe as an .ics feed to overlay it on your Outlook.',
  },
  {
    selector: '[data-tour="emp-expenses"]',
    title: 'Expense Reports',
    description: 'Create expense reports, snap or upload receipts (AI extracts the details), and submit for approval.',
  },
  {
    selector: '[data-tour="emp-travel"]',
    title: 'Travel Requests',
    description: 'Submit travel requests with passport + flight preferences. The travel manager handles booking.',
  },
  {
    selector: '[data-tour="emp-documents"]',
    title: 'Documents',
    description: 'Your employment contract and anything else HR has uploaded for you.',
  },
  {
    selector: '[data-tour="emp-help"]',
    title: 'Need Help?',
    description: 'Detailed guides for every feature. You can re-run this tour from the Help page anytime.',
  },
];
